module.exports = __webpack_public_path__ + "img/check-mark-circle3.f8443e4b.png";